<template>
  <div id="main" v-if="isReady">
    <level-card
      :levelContent="dataObj.levelCard.levelContent"
      :name="dataObj.levelCard.name"
      :level="dataObj.levelCard.level"
      :beyond="dataObj.levelCard.beyond"
      :beyondIndex="dataObj.levelCard.beyondIndex"
      :test-date="dataObj.levelCard.testDate"
      :test-inner="dataObj.levelCard.testInner"
      :grade="grade"
    ></level-card>
    <subject-analyze
      :subject-num="dataObj.subjectAnalyze.subjectNum"
      :indicator-list="dataObj.subjectAnalyze.indicatorList"
      :test-id="testId"
      :id="id"
      :grade="grade"
    ></subject-analyze>
    <compare :img-url="dataObj.compare.imgUrl" :grade="grade"></compare>
    <quick-review
      :video-url="dataObj.quickReview.videoUrl"
      :post-img="dataObj.quickReview.postImg"
      :grade="grade"
    ></quick-review>
    <future :content="dataObj.future.content" :grade="grade"></future>
  </div>
</template>

<script>
import LevelCard from "@/components/LevelCard";
import SubjectAnalyze from "@/components/SubjectAnalyze";
import Compare from "@/components/Compare";
import QuickReview from "@/components/QuickReview";
import Future from "@/components/Future";
export default {
  name: "Main",
  components: {
    "level-card": LevelCard,
    "subject-analyze": SubjectAnalyze,
    compare: Compare,
    "quick-review": QuickReview,
    future: Future
  },
  props: {
    testId: {},
    id: {},
    grade: {}
  },
  data() {
    return {
      isReady: false,
      dataObj: {
        levelCard: {
          name: "庄晓曼",
          level: "A",
          beyond: 10,
          testDate: "2019-07-01",
          testInner: "K1，0-47课时"
        },
        subjectAnalyze: {
          subjectNum: [100, 33, 60, 100],
          indicatorList: [
            {
              text: "语言艺术主题",
              max: 100,
              min: 0,
              en: "Language Arts",
              num: 100
            },
            { text: "未来领导力", max: 100, min: 0, en: "LTP", num: 33 },
            { text: "科学主题", max: 100, min: 0, en: "Science", num: 60 },
            { text: "数学主题", max: 100, min: 0, en: "Math", num: 100 }
          ]
        },
        compare: {
          imgUrl: "http://temp.im/400x400"
        },
        quickReview: {
          videoUrl: "",
          postImg: ""
        },
        future: {
          content: "未来展望"
        }
      }
    };
  },
  created() {
    this.fetch();
  },
  mounted() {},
  methods: {
    fetch() {
      console.log("fetch");
      this.$http(`student-detail/${this.testId}/${this.grade}`)
        .then(res => {
          console.log(res.data);
          let arr = [];
          res.data.subjectAnalyze.indicatorList.forEach(item => {
            arr.push(item.num);
          });
          res.data.subjectAnalyze.subjectNum = arr;
          this.dataObj = res.data;
          this.dataObj.future.content = (
            this.dataObj.future.content + ""
          ).replace(/\n/g, "<br/>");
          console.log("data", this.dataObj);
          this.isReady = true;
        })
        .catch(err => {
          alert("当前接口暂时无法访问");
        });
    }
  }
};
</script>

<style>
#main {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/Main.vue